import { Box, Button, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { type SearchSourceId } from "@/features/map/utils/buildSearchChain";
import { SEARCH_SOURCE_LABEL } from "@/features/map/utils/searchSourceMeta";

export interface NotifySourceMismatchParams {
  /** ヒットしたデータソース。 */
  sourceId: SearchSourceId;
  /**
   * 通知内のボタンを押したときに、該当レイヤーを表示する処理。
   * レイヤーを確実に切り替えられないときは未指定にし、ボタンを出さない。
   */
  onShowLayer?: () => void;
}

/** 通知が消えるまでの時間。レイヤー表示を選ぶ余裕を持たせるため既定より長くする。 */
const AUTO_CLOSE_MS = 10000;

/**
 * 非表示のデータソース（Tier 2）でヒットしたことを利用者に伝え、その場で
 * 該当レイヤーを表示できるようにする通知を出す。
 *
 * 表示していないソースの結果をそのまま出すと「見ている地図」と「結果の出どころ」が
 * ずれたままになる。ずれを黙って許容せず、切り替えられるときはワンクリックで解消できる
 * 導線を添える。表示中のソース（Tier 1）でヒットしたときはずれが無いため、呼び出さない。
 */
export const notifySourceMismatch = ({
  sourceId,
  onShowLayer,
}: NotifySourceMismatchParams): void => {
  const label = SEARCH_SOURCE_LABEL[sourceId];

  toast.info(
    ({ closeToast }) => (
      <Box>
        <Typography variant={"body2"} sx={{ mb: onShowLayer ? 1 : 0 }}>
          {label}のデータで見つかりました。
        </Typography>
        {onShowLayer && (
          <Button
            size={"small"}
            variant={"outlined"}
            sx={{ textTransform: "none" }}
            onClick={() => {
              onShowLayer();
              closeToast?.();
            }}
          >
            {label}を表示
          </Button>
        )}
      </Box>
    ),
    { autoClose: AUTO_CLOSE_MS }
  );
};
